module.exports = __webpack_public_path__ + "static/media/cnito_logo_black.85d333cc.svg";